module.exports = __webpack_public_path__ + "static/media/masters_thesis12.88c19fee.webp";